// MHO : https://github.com/react-dnd/react-dnd/pull/1425
// https://web.dev/learn/design/interaction/
// looks like there's no perfect way to detect mobile devices

import { useEffect, useState } from 'react';

export const useIsTouchDevice = () => {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    // window.matchMedia('(pointer: fine)').matches means that the device is not a touch device
    const mediaQueryList = window.matchMedia('(pointer: coarse)');

    // TODO : check if we can refactor this code in order to respect this rule
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsTouchDevice(mediaQueryList.matches);
  }, []);

  return isTouchDevice;
};
